<template>
  <div class="header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "KboSidebarHeader",
};
</script>

<style lang="scss">
.header {
  background-color: $menuHeader;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
